import { useMediaQuery } from 'react-responsive';

export const useIsDesktop = () => {
  const isDesktop = useMediaQuery({ minWidth: 550 });
  return isDesktop;
};
